import { WhitelabelConfig } from '@whitelabel/types';

const RurubuWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Rurubu',
    termsOfUseUrl: 'https://www.rurubu.travel/content/terms-of-use',
    privacyPolicyUrl: 'https://www.rurubu.travel/content/privacy-policy',
};

export default RurubuWhitelabelConfig;
